import { Form } from "formik";
import styled, { css } from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 370px;

  margin-top: 165px;

  h1 {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.4375rem;
    font-weight: bold;
    text-align: left;
    line-height: 18px;
    margin-bottom: 12px;
  }

  h2 {
    color: #5e5e5e;
    font-size: 0.9375rem;
    text-align: left;
    line-height: 26px;
    margin-bottom: 22px;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    margin-top: 45px;
    min-height: calc(100vh - 356px);
  }
`;

export const Label = styled.span`
  color: #5e5e5e;
  svg {
    margin-left: -5px;
    margin-right: 4px;
  }
  margin-bottom: 22px;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const InputsContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  button {
    margin-bottom: 20px;
  }
`;

export const Field = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TokenLink = styled.a`
  cursor: pointer;
  color: #074f8c !important;
  font-size: 0.875rem;
  line-height: 17px;

  ${props =>
    props.invalidToken &&
    css`
      color: #dc3545 !important;
    `}
`;

export const WrapSearchDocument = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
  color: #0b24fb;
  margin-top: 5px;
  margin-bottom: 16px;

  div {
    cursor: pointer;
  }

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const SearchDocumentText = styled.span`
  text-decoration-line: underline;
  cursor: pointer;
`;

export const SearchDocumentIcon = styled.div`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background: #97f8fb;
  border-radius: 50%;
  font-weight: 500;
`;
